import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

/**
 * Angular migration of NotificationFactory (admin/notification/notificationService.js).
 *
 * All notification endpoints are served by the shared `scheduler` backend service
 * (also used by gold sync), so we read the base URL from `environment.scheduler_api_url`.
 * The user lookup runs against `base_url` (gtw API), and the Process Console grid is
 * loaded via the standard `loadGridJson` endpoint (action_id=31159, grid_id=5331).
 */
@Injectable({ providedIn: 'root' })
export class NotificationService {

  /** Pre-/post-template HTML wrapping the user-edited body when html_ind === 'Y'. */
  static readonly HTML_PARTS = {
    htmlBeforeBody:
      "<!DOCTYPE html>\n<html xmlns:th=\"http://www.thymeleaf.org\">\n<head>\n<style>\n.header-bar{\nheight: 2.5px;\n    width: 60%;\n    overflow: hidden;\n    background-color: #FA5927;\n    border-spacing: 0px;\n    border-width: medium;\n    border-style: none;\n    border-collapse: collapse;\n    margin: 0px auto;\n}\n.header-content{\nlist-style-type: none;\nlist-style-type: none;\nmargin: 0;\nwidth:60%;\nheight:100%;\npadding: 0;\noverflow: hidden;\nborder-spacing:0px;\nborder-width:medium;\nborder-style:none;\nborder-collapse:collapse;\nmargin:0px auto\n}\n.pwc-logo{\nfloat: left;\nlist-style-type: none;\nmargin-top: 13px;\nmargin-left: 35px;\n}\n.gtw-module-block{\nfloat:right;\nlist-style-type: none;\npadding : 10px;\nheight:100%;\n}\n.gtw-module-link{\nfloat: left;\nlist-style-type: none;\nmargin-left:30px;\n}\n.gtw-module-link a img{\nwidth: 82%;\n}\n.launch-btn{\nfont-size: 10px;\nborder-radius: 3px;\npadding: 8px;\nbackground-color: white;\nwidth: 100px;\nborder-style: solid;\nborder-color:#FA5927;\nfloat: right;\nmargin-top: 10px;\nmargin-right: 10px;\nborder-style: solid;\nborder-width: 0.7px;\n}\n.launch-btn a{\ntext-decoration: none;\ncolor: #FA5927;\n}\n.body-container{\nbackground-color:#e8e7e8;\nwidth:60%;\nmin-height: 380px;\nborder-spacing:0px;\nborder-width:medium;\nborder-style:none;\nborder-collapse:collapse;\nmargin:0px auto;\nfont-family: arial;\nbox-shadow: inset 0px 7px 1px -6px rgba(50, 50, 50, 0.75);\n}\n.body-main{\nbackground-color: white;\npadding:10px;\nmargin-left: 15px;\nmargin-top:0px;\nmargin-right: 15px;\nfont-family: arial;\nborder-radius :3px;\n}\n.exception-header{\nmargin-left:10px;\nfont-size : 18px;\n}\n.details-block{\nborder-top:1px solid #dadada;\nborder-bottom:1px solid #dadada;\nmargin-top: -10px;\nmargin-left:10px;\nmargin-right:10px;\n}\n.details-table{\nmargin-top: 7px;\nmargin-left: -5px;\n}\n.details-table td{\ntext-align: left;\npadding: 5px;width:500px;\nfont-size: 12px;\n}\n.view-error-btn{\nborder-radius: 2px;\nfont-size:10px;\npadding: 8px;\nmargin-left:0px;\nwidth: 100px;\nbackground-color:#FA5927;\nborder: none;color:white;\nbox-shadow: 0px 4px 4px #8888887a;\n}\n#stacktrace{\nmargin-left:10px;\n}\n#stacktrace .stack-label{\nfont-size:15px;\n}\n#stacktrace .stack-details{\nfont-size:12px;\n}\n.footer-table{\nbackground-color: rgb(255,255,255);\n    width: 60%;\n    border-spacing: 0px;\n    border-width: medium;\n    border-style: none;\n    border-collapse: collapse;\n    margin: 0px auto;\n    font-family: Arial;\n}\n.footer-body{\nbackground-color: #1B282E;\n    opacity: 0.9;\n}\n.notice-block{\nborder-spacing:0px;\n}\n.copy-right-block{\nbackground-color: #131B1F;\nopacity : 0.9;\ncolor: white;\n}\n.notice-block td{\npadding: 2%;\n}\n.module{\nfont-size:14px;\ncolor:#FA5927;\nfont-family: arial;\nmargin-left: 15px;\n}\n.module_sub{\nfont-size: 11px;\ncolor:white\n}\n.confidential{\nfont-family: arial;\nmargin-left: 15px;\nfont-size:12px;\ncolor:#ffffff;\n}\n.notice{\nfont-family: arial;\nmargin-left: 15px;\nmargin-top:-5px;\nfont-size: 11px;\ncolor:#ffffff;\n}\n.copy-right{\nfont-family: arial;\ntext-align : center;\nmargin-right: 25px;\nmargin-left: 25px;\nfont-size:10px;\n}\n</style>\n</head>\n<div class=\"header-bar\"></div>\n<div style=\"height:65px;\">\n<ul class=\"header-content\">\n<li class=\"pwc-logo\">\n<a href=\"#home\"><img src=\"pwc_logo.jpg\" th:src=\"'cid:' + ${imageResourcePwc}\" alt=\"pwc-header-sm\"/></a>\n</li>\n<li class=\"gtw-module-block\">\n<button type=\"button\" class=\"launch-btn gtw\">\n<a th:href=\"${gtw_ui_url}\" target=\"_blank\">LAUNCH GTW</a>\n</button>\n</li>\n<li class=\"gtw-module-link\">\n<a><img src=\"gtw_logo.png\" th:src=\"'cid:' + ${imageResourceGtw}\" alt=\"pwc-header-sm\"></a>\n</li>\n</ul>\n</div>\n<div class=\"body-container\"><br>\n<div class=\"body-main\">\n",
    htmlAfterBody:
      "</div>\n</div><table class=\"footer-table\">\n<tbody class=\"footer-body\">\n<tr class=\"notice-block\">\n<td>\n<p class=\"module\"><b>GTW</b> <span class=\"module_sub\">(Global Tax Workspace)</span></p>\n<p class=\"confidential\">CONFIDENTIALITY NOTICE :</p>\n<p class=\"notice\">\nThis email is intended only for the person(s) named in the message header. Unless otherwise indicated, it contains information that is confidential, privileged and/or exempt from disclosure under applicable law. If you have received this message in error, please notify the sender of the error and delete the message. Thank you.</p>\n</td>\n</tr>\n<tr class=\"copy-right-block\">\n<td>\n<p class=\"copy-right\">&#169; 2020 PwC. PwC refers to the PwC network and/or one or more of its member firms,each of which is a separate legal entity .Please see www.pwc.com/structure for further details</p>\n</td>\n</tr>\n</tbody>\n </table></html>",
  };

  constructor(private http: HttpClient) {}

  private get schedulerBaseUrl(): string {
    return environment.scheduler_api_url;
  }

  private get baseUrl(): string {
    return environment.base_url;
  }

  // ---------------------------------------------------------------------------
  // Process list & details
  // ---------------------------------------------------------------------------

  getProcessList(): Observable<any> {
    return this.http.get<any>(`${this.schedulerBaseUrl}/getProcesses`, { withCredentials: true });
  }

  getProcessDetails(processName: string): Observable<any> {
    return this.http.get<any>(
      `${this.schedulerBaseUrl}/getProcessDetails/${encodeURIComponent(processName)}`,
      { withCredentials: true }
    );
  }

  saveProcessDetails(process: any): Observable<any> {
    return this.http.post<any>(
      `${this.schedulerBaseUrl}/saveProcessDetails/${encodeURIComponent(process?.process_name || '')}`,
      JSON.stringify(process),
      {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true,
      }
    );
  }

  // ---------------------------------------------------------------------------
  // On Demand Notification
  // ---------------------------------------------------------------------------

  sendNotification(notifData: any): Observable<any> {
    const fd = new FormData();
    fd.append('client_key', String(notifData?.client_key ?? ''));
    fd.append('email_addr', notifData?.email_addr || '');
    fd.append('payload', notifData?.payload || '');
    fd.append('process_name', notifData?.process_name || '');
    fd.append('source_name', notifData?.source_name || 'GTW');
    fd.append('sso', notifData?.sso || '');
    fd.append('subject', notifData?.subject || '');
    return this.http.post<any>(`${this.schedulerBaseUrl}/addNotification`, fd, {
      withCredentials: true,
    });
  }

  // ---------------------------------------------------------------------------
  // Process Console
  // ---------------------------------------------------------------------------

  /** Resend a single notification by its NOTIFY_ID. */
  resendNotification(notificationId: string | number): Observable<any> {
    return this.http.get<any>(
      `${this.schedulerBaseUrl}/resendNotification/${encodeURIComponent(String(notificationId))}`,
      { withCredentials: true }
    );
  }

  // ---------------------------------------------------------------------------
  // User typeahead lookup (used by Email TO/CC/BCC and On-Demand TO)
  // ---------------------------------------------------------------------------

  getUserLookup(userName: string): Observable<any> {
    return this.http.post<any>(
      `${this.baseUrl}/userDetails`,
      { userName },
      { withCredentials: true }
    );
  }

  // ---------------------------------------------------------------------------
  // Helpers (mirror NotificationFactory utility methods)
  // ---------------------------------------------------------------------------

  isDuplicateEmail(emailList: any[], email: { emailAddress: string }): boolean {
    if (!Array.isArray(emailList) || !email?.emailAddress) return false;
    const target = String(email.emailAddress).toUpperCase();
    return emailList.some((item: any) => String(item?.emailAddress || '').toUpperCase() === target);
  }

  getHtmlParts(): { htmlBeforeBody: string; htmlAfterBody: string } {
    return NotificationService.HTML_PARTS;
  }
}
